import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  onSavePreset,
  companies,
  statuses,
  categories 
}) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-brand mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" />
          Advanced Filters
        </h3>
        <div className="flex gap-2">
          <Button 
            variant="outline" 
            size="sm" 
            iconName="Save" 
            iconPosition="left"
            onClick={onSavePreset}
          >
            Save Preset
          </Button>
          <Button 
            variant="ghost" 
            size="sm" 
            iconName="X" 
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear All
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          label="Search"
          type="search"
          placeholder="Name, email, or ID..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          label="Company"
          placeholder="All Companies"
          options={companies}
          value={filters?.company}
          onChange={(value) => onFilterChange('company', value)}
          clearable
        />

        <Select
          label="Status"
          placeholder="All Statuses"
          options={statuses}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          clearable
        />

        <Select
          label="Category"
          placeholder="All Categories"
          options={categories}
          value={filters?.category}
          onChange={(value) => onFilterChange('category', value)}
          clearable
        />

        <Input
          label="Date From"
          type="date"
          value={filters?.dateFrom}
          onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
        />

        <Input
          label="Date To"
          type="date"
          value={filters?.dateTo}
          onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
        />

        <Select
          label="Department"
          placeholder="All Departments"
          options={[
            { value: 'engineering', label: 'Engineering' },
            { value: 'design', label: 'Design' },
            { value: 'marketing', label: 'Marketing' },
            { value: 'sales', label: 'Sales' },
            { value: 'hr', label: 'Human Resources' }
          ]}
          value={filters?.department}
          onChange={(value) => onFilterChange('department', value)}
          clearable
        />

        <Select
          label="Completion Rate"
          placeholder="Any Rate"
          options={[
            { value: '0-25', label: '0-25%' },
            { value: '26-50', label: '26-50%' },
            { value: '51-75', label: '51-75%' },
            { value: '76-100', label: '76-100%' }
          ]}
          value={filters?.completionRate}
          onChange={(value) => onFilterChange('completionRate', value)}
          clearable
        />
      </div>
    </div>
  );
};

export default FilterPanel;